import { request } from '../utils/request'
import { querystring } from '../utils/index'

export default {
  gettracingenvinfos: option =>
    request('v1/tracingenv/gettracingenvinfos', option, true, false), // 查询溯源环境信息列表
  gettracingenvinfo: option => {
    const urls = querystring(option)
    return request('v1/tracingenv/gettracingenvinfo' + urls, {}, true, false) // 查询溯源环境信息
  },
  addtracingenvinfo: option =>
    request('v1/tracingenv/addtracingenvinfo', option, true, false), // 新增溯源环境信息
  updatetracingenvinfo: option =>
    request('v1/tracingenv/updatetracingenvinfo', option, true, false), // 修改溯源环境信息
  deletetracingenvinfo: option => {
    const urls = querystring(option)
    return request('v1/tracingenv/deletetracingenvinfo' + urls, {}, true, false) //  删除溯源环境信息
  },
  gettracingenvinfotemplate: option => {
    const urls = querystring(option)
    return request('v1/tracingenv/gettracingenvinfotemplate' + urls, {}, true, false) // 查询环境扩展字段
  }
}
